// import { useEffect, useState, useMemo } from "react";
// import ProductCard from "../../../components/ProductCard";
// import ProductCardSkeleton from "../../../components/ProductCardSkeleton";
// import SliderComp from "../../../components/SliderComp";
// import API from "../../../utils/api";
// import classes from "./Section8.module.css";

// const getImageUrl = (imageName) => {
//   const baseUrl = API.base.endsWith("/serverstock_api")
//     ? API.base
//     : `${API.base}/serverstock_api`;

//   if (!imageName) {
//     return `${baseUrl}/upload/placeholder-image.jpg`;
//   }
//   return `${baseUrl}/upload/${imageName}`;
// };

// export default function Section8() {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     async function fetchMemoryProducts() {
//       setLoading(true);
//       try {
//         // Fetch all categories
//         const catsRes = await API.post("/categories.php", { action: "fetch" });
//         const categories = Array.isArray(catsRes.data)
//           ? catsRes.data
//           : catsRes.data?.data || [];

//         // Find **Memory** category
//         const memoryCat = categories.find(
//           (cat) =>
//             cat.categoryName?.toLowerCase() === "memory" ||
//             cat.category_slug === "memory"
//         );

//         if (!memoryCat) {
//           console.warn("Memory category not found");
//           setProducts([]);
//           return;
//         }

//         // Find ALL CHILD CATEGORIES
//         const childCategories = categories.filter(
//           (cat) => cat.parent_id === memoryCat.id
//         );

//         const categorySlugs = [
//           memoryCat.category_slug,
//           ...childCategories.map((c) => c.category_slug),
//         ];

//         // Fetch products
//         const productsRes = await fetch(`${API.base}/products.php`, {
//           method: "POST",
//           headers: { "Content-Type": "application/x-www-form-urlencoded" },
//           body: new URLSearchParams({ action: "fetch", status: "publish" }),
//         }).then((res) => res.json());

//         const allProducts = Array.isArray(productsRes)
//           ? productsRes
//           : productsRes.data || [];

//         // Filter products of Memory + child cats
//         const filtered = allProducts
//           .filter((p) => categorySlugs.includes(p.category_slug))
//           .map((product) => ({
//             ...product,
//             productImage: getImageUrl(product.productImage),
//           }));

//         setProducts(filtered);
//       } catch (err) {
//         console.error("Section7 fetch error:", err);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchMemoryProducts();
//   }, []);

//   return (
//     <div className={classes.section7Wrapper}>
//       {/* Heading with lines */}
//       <div className={classes.headingWrapper}>
//         <div className={classes.line}></div>
//         <h2 className={classes.heading}>Memory</h2>
//         <div className={classes.line}></div>
//       </div>

//       {loading ? (
//         <div className={classes.skeletonWrapper}>
//           <ProductCardSkeleton count={4} />
//         </div>
//       ) : products.length ? (
//         <SliderComp slidesToShow={4}>
//           {products.map((product) => (
//             <div key={product.id} className={classes.sliderItem}>
//               <ProductCard product={product} />
//             </div>
//           ))}
//         </SliderComp>
//       ) : (
//         <p className="text-center text-muted">No Memory products found.</p>
//       )}
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import ProductCard from "../../../components/ProductCard";
import ProductCardSkeleton from "../../../components/ProductCardSkeleton";
import SliderComp from "../../../components/SliderComp";
import API from "../../../utils/api";
import classes from "./Section8.module.css";

const getImageUrl = (imageName) => {
  const baseUrl = API.base.endsWith("/serverstock_api")
    ? API.base
    : `${API.base}/serverstock_api`;
  return imageName
    ? `${baseUrl}/upload/${imageName}`
    : `${baseUrl}/upload/placeholder-image.jpg`;
};

export default function Section8() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchMemoryProducts() {
      setLoading(true);
      try {
        // Fetch all categories
        const catsRes = await API.post("/categories.php", { action: "fetch" });
        const categories = Array.isArray(catsRes.data)
          ? catsRes.data
          : catsRes.data?.data || [];

        // Find Memory category
        const memoryCat = categories.find(
          (cat) =>
            cat.categoryName?.toLowerCase() === "memory" ||
            cat.category_slug === "memory"
        );

        if (!memoryCat) {
          console.warn("Memory category not found");
          if (mounted) setProducts([]);
          return;
        }

        // Collect parent + child category slugs
        const categorySlugs = [
          memoryCat.category_slug,
          ...categories
            .filter((cat) => cat.parent_id === memoryCat.id)
            .map((c) => c.category_slug),
        ];

        // Fetch all products
        const res = await fetch(`${API.base}/products.php`, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({ action: "fetch", status: "publish" }),
        });

        const data = await res.json();
        const allProducts = Array.isArray(data) ? data : data.data || [];

        // Filter products by Memory + child categories & limit to 6
        const filtered = allProducts
          .filter((p) => categorySlugs.includes(p.category_slug))
          .slice(0, 6)
          .map((p) => ({
            ...p,
            productImage: getImageUrl(p.productImage),
          }));

        if (mounted) setProducts(filtered);
      } catch (err) {
        console.error("Section8 fetch error:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchMemoryProducts();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className={classes.section7Wrapper}>
      {/* Heading with lines */}
      <div className={classes.headingWrapper}>
        <div className={classes.line}></div>
        <h2 className={classes.heading}>Memory</h2>
        <div className={classes.line}></div>
      </div>

      {loading ? (
        <div className={classes.skeletonWrapper}>
          <ProductCardSkeleton count={4} />
        </div>
      ) : products.length ? (
        <SliderComp slidesToShow={4}>
          {products.map((product) => (
            <div key={product.id} className={classes.sliderItem}>
              <ProductCard product={product} />
            </div>
          ))}
        </SliderComp>
      ) : (
        <p className="text-center text-muted">No Memory products found.</p>
      )}
    </div>
  );
}
